"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchCannabinoidHelpers = void 0;
const products_1 = require("@getgreenline/products");
class BatchCannabinoidHelpers {
}
exports.BatchCannabinoidHelpers = BatchCannabinoidHelpers;
BatchCannabinoidHelpers.hasBatchCannabinoidMetadata = (batch) => {
    if (!batch.cannabinoidMetaData ||
        batch.cannabinoidMetaData.length === 0 ||
        !batch.cannabinoidMetaData[0].metaData) {
        return false;
    }
    return batch.cannabinoidMetaData[0].metaData.some((data) => data.metaValue !== null &&
        (data.metaKey.toLowerCase().includes('thc') || data.metaKey.toLowerCase().includes('cbd')));
};
BatchCannabinoidHelpers.isBatchInRange = (batch, product, cbdFilterOption, thcFilterOption, unitFilterOption) => {
    let thcFilterInRange = true;
    let cbdFilterInRange = true;
    if (!product) {
        return false;
    }
    if (!batch ||
        !batch.cannabinoidMetaData ||
        batch.cannabinoidMetaData.length === 0 ||
        !batch.cannabinoidMetaData[0].metaData) {
        // For batches without batch meta data
        if (thcFilterOption.isSet) {
            thcFilterInRange =
                thcFilterOption.isInRange(product.metaData) &&
                    unitFilterOption.isMatching(product.metaData);
        }
        if (cbdFilterOption.isSet) {
            cbdFilterInRange =
                cbdFilterOption.isInRange(product.metaData) &&
                    unitFilterOption.isMatching(product.metaData);
        }
        return thcFilterInRange && cbdFilterInRange;
    }
    const batchMetaDataHasTHC = batch.cannabinoidMetaData[0].metaData.some((MD) => MD.metaKey.toLowerCase().includes('thc') && MD.metaValue);
    const batchMetaDataHasCBD = batch.cannabinoidMetaData[0].metaData.some((MD) => MD.metaKey.toLowerCase().includes('cbd') && MD.metaValue);
    const metaDataHash = {};
    batch.cannabinoidMetaData[0].metaData.forEach((item) => {
        if (item.metaKey && item.metaValue) {
            metaDataHash[item.metaKey] = item.metaValue;
        }
    });
    // Check if UNIT metaKey is present in the batch metaData
    // TODO: remove it after GR-8429 is completed
    // https://blazesolutions.atlassian.net/browse/GR-8429
    const hasUnitKey = products_1.MetaDataModels.MetaDataReservedKeys.UNIT in metaDataHash;
    const hasUnitValue = hasUnitKey && metaDataHash[products_1.MetaDataModels.MetaDataReservedKeys.UNIT];
    if (!hasUnitKey || !hasUnitValue) {
        metaDataHash[products_1.MetaDataModels.MetaDataReservedKeys.UNIT] = products_1.UnitModels.ThcCbdUnit.PERCENT;
    }
    if (thcFilterOption.isSet) {
        const targetMetaData = batchMetaDataHasTHC ? metaDataHash : product.metaData;
        thcFilterInRange =
            thcFilterOption.isInRange(targetMetaData) && unitFilterOption.isMatching(targetMetaData);
    }
    if (cbdFilterOption.isSet) {
        const targetMetaData = batchMetaDataHasCBD ? metaDataHash : product.metaData;
        cbdFilterInRange =
            cbdFilterOption.isInRange(targetMetaData) && unitFilterOption.isMatching(targetMetaData);
    }
    return thcFilterInRange && cbdFilterInRange;
};
//# sourceMappingURL=BatchCannabinoidHelpers.js.map